import { gsap } from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, fadeIn, fadeOut, fadeInWithDelay } from "../../../js/animations/animations";

(() => {
  const BRHSlideTabCarousel = () => {
    const selectors = {
      component: "brh-slide-tab-carousel",
      filterTransition: 750,
    };

    const init = () => {
      const filterByCategory = (category, swiper, slidesCopy) => {
        const swiperWrapper = swiper.querySelector(".swiper-wrapper");
        fadeOut({ classElement: swiperWrapper, duration: 0.5 });
        const arrowNext = swiper.querySelector(".swiper-button-next");
        const arrowPrev = swiper.querySelector(".swiper-button-prev");
        setTimeout(() => {
          const minHeight = swiperWrapper.getBoundingClientRect().height;
          swiperWrapper.style.minHeight = minHeight + "px";
          swiperWrapper.innerHTML = "";
        }, 500);
        slidesCopy.forEach((slide) => {
          setTimeout(() => {
            if (slide.dataset.filter.includes(category) && category != "all-categories") {
              swiperWrapper.appendChild(slide);
              if (swiperWrapper.children.length <= 3) {
                if (arrowNext && arrowPrev) {
                  arrowNext.style.setProperty("display", "none", "important");
                  arrowPrev.style.setProperty("display", "none", "important");
                }
                swiper.classList.remove("mod--all-mode");
              } else {
                if (arrowNext && arrowPrev) {
                  arrowNext.style.display = "block";
                  arrowPrev.style.display = "block";
                }
                swiper.classList.add("mod--all-mode");
              }
            } else if (category == "all-categories") {
              swiperWrapper.appendChild(slide.cloneNode(true));
              if (arrowNext && arrowPrev && window.innerWidth > 1024) {
                arrowNext.style.setProperty("display", "block", "important");
                arrowPrev.style.setProperty("display", "block", "important");
              }
              swiper.classList.add("mod--all-mode");
            }
            fadeInWithDelay({ classElement: swiperWrapper, duration: 1, delay: 0 });
          }, selectors.filterTransition);
        });
      };

      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          const arrowNext = element.querySelector(".swiper-button-next");
          const arrowPrev = element.querySelector(".swiper-button-prev");
          const swiperElement = element?.querySelector(".swiper");
          const slidesCopy = element.querySelectorAll(".brh-slide-tab-carousel-item");
          if (swiperElement) {
            const wrapper = swiperElement.firstElementChild;
            const slideLength = element.querySelectorAll(".brh-slide-carousel-item").length;
            const tabsItem = element.querySelectorAll(".brh-slide-tab-carousel__tabs-item");
            if (tabsItem) {
              tabsItem.forEach((e, i) => {
                if (i == 0) {
                  e.classList.add("mod--active");
                }
                e.addEventListener("click", () => {
                  tabsItem.forEach((tab) => {
                    tab.classList.remove("mod--active");
                  });
                  e.classList.add("mod--active");
                  filterByCategory(e.getAttribute("data-filter"), swiperElement, slidesCopy);
                });
              });
            }

            [...element.querySelector(".swiper-wrapper").children].forEach((element) => {
              element.classList.add("swiper-slide");
              if (element.firstElementChild) {
                element.setAttribute("data-filter", element.firstElementChild.getAttribute("data-filter"));
              }
            });
            if (slideLength > 3 || window.innerWidth < 1024) {
              const swiper = new window.Swiper(element.querySelector(".swiper"), {
                slidesPerView: window.innerWidth > 1024 ? 3.4 : 1.3,
                spaceBetween: window.innerWidth > 1024 ? 20 : 18,
                // freeMode: true,
                freeMode: false,
                // loop: window.innerWidth > 1024 ? true : false,
                loop: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });

              const tabsItem = element.querySelectorAll(".brh-slide-tab-carousel__tabs-item");
              if (tabsItem) {
                tabsItem.forEach((e) => {
                  e.addEventListener("click", () => {
                    setTimeout(() => {
                      swiper.activeIndex = 1;
                      swiper.update();
                      swiper.slideNext();
                      swiper.slideNext();
                      if (window.innerWidth <= 1024) {
                        swiper.slideTo(0);
                      }
                    }, 900);
                  });
                });
              }
              arrowPrev.addEventListener("click", function () {
                swiper.slidePrev();
              });

              arrowNext.addEventListener("click", function () {
                swiper.slideNext();
              });

              swiperElement.classList.add("mod--all-mode");

              window.addEventListener("resize", () => {
                swiper.params.slidesPerView = window.innerWidth > 1024 ? 3.5 : 1.3;
                swiper.params.spaceBetween = window.innerWidth > 1024 ? 20 : 18;
                swiper.update();
              });
            } else {
              wrapper.style.gap = "20px";

              if (arrowNext && arrowPrev) {
                arrowNext.style.display = "none";
                arrowPrev.style.display = "none";
              }
            }
          }
        });
      }

      //== Animations
      if (!isMobile() && !isAuthor()) {
        const carousels = document.querySelectorAll(`.${selectors.component}`);
        if (carousels.length > 0) {
          carousels?.forEach((element) => {
            const wrappers = element.querySelectorAll(".swiper-wrapper");
            const appearances = gsap.timeline();
            wrappers.length > 0 && appearances.add(fadeIn({ classElement: wrappers, duration: 2 }), 0);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHSlideTabCarousel);
})();
